import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withReporting } from 'provider/reporting';
import { get } from 'utils';
import { OPERATORS } from 'consts/filters';
import { DashboardFilterFormUI } from './ui';

const OPERATOR = [
    { label: 'is', value: OPERATORS.is },
    { label: 'is not', value: OPERATORS.isNot }
];

export class DashboardFilterForm extends PureComponent {
    static displayName = 'DashboardFilterFormContainer';

    static propTypes = {
        capabilities: PropTypes.arrayOf(PropTypes.string),
        dateRange: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])),
        equityScope: PropTypes.arrayOf(PropTypes.any),
        filters: PropTypes.arrayOf(PropTypes.any),
        hideLabel: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        reporter: PropTypes.shape({
            actions: PropTypes.object,
            objects: PropTypes.object,
            track: PropTypes.func
        }).isRequired,
        styles: PropTypes.objectOf(PropTypes.any)
    };

    static defaultProps = {
        dateRange: undefined,
        equityScope: [],
        filters: [],
        hideLabel: false,
        capabilities: [],
        styles: undefined
    };

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onShowMenu = this.onShowMenu.bind(this);
        this.changeView = this.changeView.bind(this);
        this.onChangeOperator = this.onChangeOperator.bind(this);

        this.state = {
            view: 'menu',
            operator: OPERATORS.is
        };
    }

    onChangeOperator({ value }) {
        this.setState({ operator: value });
    }

    onChange({ event, name, value, label }) {
        const { operator } = this.state;
        const { onChange, equityScope, reporter } = this.props;
        const newEquityScope = [...(equityScope || [])];
        const hasSectorId = get(value, 'gicsSectorId', get(value, 'gicsSubSectorId'));
        if (typeof value === 'string' || hasSectorId || Array.isArray(value)) {
            if (name === 'equity' || name === 'watchlist' || name === 'sector' || name === 'index') {
                // Search for existing filter in current equity scope
                const hasExistingScope = (equityScope || []).find(({ type: typeVal, value: scopeVal }) => {
                    const scopeSectorId = get(scopeVal, 'gicsSectorId', get(scopeVal, 'gicsSubSectorId'));
                    // Compare types, and values or sector ids
                    return typeVal === name && (scopeVal === value || (hasSectorId && hasSectorId === scopeSectorId));
                });
                if (!hasExistingScope) {
                    newEquityScope.push({
                        type: name,
                        value,
                        label,
                        operator: name === 'sector' ? operator : undefined // passing operator to parent as long as has sector
                    });
                    onChange({
                        event,
                        name: 'dashEquityScope',
                        value: newEquityScope
                    });
                }
            } else {
                onChange({ event, name, value });
            }

            // Track Monitor Filter
            reporter.track(reporter.actions.submit, reporter.objects.monitorFilter, {
                component: 'DashboardFilterForm',
                name,
                value,
                label
            });

            if (this.hideMenu) {
                this.hideMenu();
            }
        }
    }

    onShowMenu({ hideTooltip }) {
        this.hideMenu = hideTooltip;
        this.changeView('menu');
        this.setState({ operator: OPERATORS.is });
    }

    changeView(view) {
        this.setState({
            view,
            operator: OPERATORS.is
        });
    }

    render() {
        const { capabilities, dateRange, styles, equityScope, filters, hideLabel } = this.props;
        const { view, operator } = this.state;
        return (
            <DashboardFilterFormUI
                capabilities={capabilities}
                changeView={this.changeView}
                dateRange={dateRange}
                hasFilters={
                    !!dateRange || (!!equityScope && equityScope.length > 0) || (!!filters && filters.length > 0)
                }
                hideLabel={hideLabel}
                onChange={this.onChange}
                onShowMenu={this.onShowMenu}
                styles={styles}
                view={view}
                operatorOptions={OPERATOR}
                onChangeOperator={this.onChangeOperator}
                operator={operator}
            />
        );
    }
}

export const DashboardFilterFormContainer = compose(withReporting())(DashboardFilterForm);
